<template>
    <div class="kt-portlet__head-toolbar">
        <ul class="nav nav-tabs nav-tabs-line nav-tabs-line-success" role="tablist">
            <slot></slot>
        </ul>
    </div>
</template>
